import React, { useEffect } from "react";
import Label from "../../components/Label";
import Button from "../../components/Button";
import * as extractionServices from "../../services/extractionsServices";
import Table from "../../components/Table";
import { TextField } from "@mui/material";
import i18next from "i18next";
import { constants, routes, utils } from "../../utils";
import { useNavigate } from "react-router";
import SimpleDialog from "../../components/SimpleDialog";
import Loader from "../../components/Loader";

type Params = { rol?: string; search?: string; roles?: string[]; limit: number };

const columns = ["code"];

export default function ExtractionList() {
	const [data, setData] = React.useState<any>({ result: [], total: 0 });
	const [params, setParams] = React.useState<Params>({
		roles: [],
		rol: "",
		search: "",
		limit: constants.DEFAULT_PAGE_SIZE,
	});
	const [loading, setLoading] = React.useState<boolean>(false);

	useEffect(() => {
		getExtractions(params);
	}, []);

	const getExtractions = async (newParms: Params) => {
		setLoading(true);
		const data = await extractionServices.search(newParms);
		setData(data);
		setLoading(false);
	};

	const navigate = useNavigate();

	const handleUpdate = (options: any) => extractionServices.search(options).then((data) => setData(data));

	const handleChangeSearch = utils.debounce((e) => {
		var newParms = params;

		newParms = { ...params, search: e.target.value };

		extractionServices.search(newParms).then((data) => data && setData(data));

		setParams({ ...newParms });
	}, constants.DEBOUNCE_TIME);

	return (
		<SimpleDialog open={true} onClose={() => navigate(-1)}>
			<Label isTitle titleCassName="mb-3" text={i18next.t("extractions-list")} />
			<Table
				onRowPress={(extraction) => {
					navigate(routes.EXTRACTION(extraction.id));
				}}
				columns={columns}
				rows={data.result}
				total={data.total}
				keyExtractor={(row: any) => row.id}
				handleUpdate={handleUpdate}
				filtersComponents={
					<div className="d-flex align-items-center my-3" style={{ width: 400 }}>
						<TextField
							size="small"
							placeholder={i18next.t("search")}
							inputProps={{ "data-testid": "search-input" }}
							onChange={handleChangeSearch}
						/>
					</div>
				}
			/>
			<div className="d-flex mt-4 justify-content-between">
				{loading ? <Loader /> : <div />}
				<Button
					label={i18next.t("go-back")}
					secondary
					onClick={() => navigate(routes.DASHBOARD)}
					className="ms-4"
				/>
			</div>
		</SimpleDialog>
	);
}
